import { render, staticRenderFns } from "./DriverTaskManage.vue?vue&type=template&id=42fb98ed&scoped=true"
import script from "./DriverTaskManage.vue?vue&type=script&lang=js"
export * from "./DriverTaskManage.vue?vue&type=script&lang=js"
import style0 from "./DriverTaskManage.vue?vue&type=style&index=0&id=42fb98ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb98ed",
  null
  
)

export default component.exports